import { useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Textarea } from '@/components/ui/textarea'

interface ReleaseDialogProps {
  priorityTitle: string
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: (note: string) => void
}

export function ReleaseDialog({
  priorityTitle,
  open,
  onOpenChange,
  onConfirm,
}: ReleaseDialogProps) {
  const [note, setNote] = useState('')

  function handleConfirm() {
    onConfirm(note)
    setNote('')
    onOpenChange(false)
  }

  function handleOpenChange(next: boolean) {
    if (!next) setNote('')
    onOpenChange(next)
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Release "{priorityTitle}"?</DialogTitle>
          <DialogDescription>
            Prayerfully set this down. Briefly note why — the act of release deserves a word.
          </DialogDescription>
        </DialogHeader>

        <Textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Why are you releasing this? (optional)"
          rows={3}
          className="resize-none"
          autoFocus
        />

        <DialogFooter>
          <Button variant="ghost" onClick={() => handleOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={handleConfirm}>Release</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
